import styled from "styled-components";
import { FlexCenter } from "../StyledComponents";

export const PatientInfo = styled.div`
  font-weight: 600;
  font-size: 26px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LightText = styled.span`
  font-weight: 600 !important;
`;

export const CircleOverImage = styled(FlexCenter)`
  border-radius: 50%;
  height: 58px;
  width: 58px;
  margin-right: 16px;
  border: 1.5px solid #e9eef9;
  position: relative;

  & .blue-curve {
    position: absolute;
    top: -1.5px;
    right: -1.5px;
  }
`;

export const SubContainer = styled.div``;

export const Div_1 = styled.div`
  display: ${(p) => p.display && p.display};
  justify-content: ${(p) => p.JustifyContent && p.JustifyContent};
  flex: ${(p) => p.flex && p.flex};
  height: ${(p) => p.height && p.height};
  //   ${(p) =>
    //     p.gridTop &&
    //     `
    //     @media only screen and (min-width: 2560px) {
    //       display : grid;
    //       grid-template-areas:
    //       "Appointment Bill cards"
    //       "Group Group Medication"
    //  ;
    //       grid-template-columns: 1fr 1fr 1fr;
    //       grid-template-rows:385px 353px;
    //       column-gap: 38px;
    //       row-gap:32px;

    //       }
    //       @media only screen and (max-width: 2560px) {
    //         display : grid;
    //         grid-template-areas:
    //         "Appointment Bill cards"
    //         "Group Group Medication"
    //    ;
    //         grid-template-columns: 1fr 1fr 1fr;
    //         grid-template-rows:385px 353px;
    //         column-gap: 38px;
    //         row-gap:32px;

    //         }
    //       @media only screen and (max-width: 1440px) {
    //         display : grid;
    //         grid-template-areas:
    //         "Appointment Bill cards"
    //         "Group Group Medication"
    //    ;
    //         grid-template-columns: 1fr 1fr 1fr;
    //         grid-template-rows:385px 353px;
    //         column-gap: 38px;
    //         row-gap:32px;
    //         }
    //         @media only screen and (max-width: 1280px) {
    //           display : grid;
    //           grid-template-areas:
    //           "Appointment Bill"
    //           "cards Medication"
    //           "Group Group";
    //           grid-template-columns: 1fr 1fr ;
    //           grid-template-rows:385px 353px 353px;
    //           column-gap: 38px;
    //           row-gap:32px;

    //           }
    //           @media only screen and (max-width: 950px) {
    //             display : grid;
    //             grid-template-areas:
    //             "Appointment"
    //             "Bill"
    //             "cards"
    //              "Medication"
    //             "Group";
    //             grid-template-columns: 1fr;
    //             grid-template-rows:385px 385px 353px 353px 353px;
    //             column-gap: 38px;
    //             row-gap:32px;

    //             }
    //     `}

    p.gridTop &&
    `
  display: grid;
  grid-template-areas:
    "Appointment Bill"
    "RowTwo RowTwo";

  grid-template-columns: 2fr 1fr;
  grid-auto-rows: auto;

  column-gap: 14px;
  row-gap: 14px;

  /* Large Screens (1440+) */
  @media only screen and (min-width: 1441px) {
    grid-template-columns: 2fr 1fr;
  }

  /* Laptop Screens (1025px - 1440px) */
  @media only screen and (max-width: 1440px) and (min-width: 1025px) {
    grid-template-columns: 2fr 1fr;
  }

  /* Tablet */
  @media only screen and (max-width: 1024px) {
    grid-template-areas:
      "Appointment"
      "Bill"
      "RowTwo";

    grid-template-columns: 1fr;
  }

  /* Mobile */
  @media only screen and (max-width: 768px) {
    grid-template-areas:
      "Appointment"
      "Bill"
      "RowTwo";

    grid-template-columns: 1fr;
  }
`}
`;

export const RowTwoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: 14px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const CurveImg = styled.img`
  width: ${(p) => p.width && p.width};
  height: ${(p) => p.height && p.height};
  position: ${(p) => p.position && p.position};
  top: ${(p) => p.top && p.top};
  left: ${(p) => p.left && p.left};
  right: ${(p) => p.right && p.right};
`;
